import { getGPTSummary } from '@/infrastructure/api-functions';
import { reportService } from '@/services/report-service';
import type { IPatentGPTSummary, TRANSLATE_LANGUAGES } from '@/types';
import { onMounted, ref } from 'vue';

export function useDocumentCompareGPT(data: {
    patent_id: string,
    inputLang: TRANSLATE_LANGUAGES,
    transLang: TRANSLATE_LANGUAGES,
}) {
    const gptSummary = ref<IPatentGPTSummary>();
    const gptLoading = ref(false);

    onMounted(() => {
        gptLoading.value = true;
        getGPTSummary({
            patent_id: data.patent_id,
            lang: data.inputLang,
            trans_lang: data.transLang,
        }).then((res) => {
            gptSummary.value = res
            reportService.value.finishCount += 1;
            console.log('报告数量---' + reportService.value.reportLength)
            console.log('GPT完成数量---' + reportService.value.finishCount)
            console.log('GPT是否完成--- ' + reportService.value.allGptFinish);
        }).finally(() => {
            gptLoading.value = false;
        })
    })

    return {
        gptSummary,
        gptLoading,
    }
}
